<template>
    <div class="finalScore">
        <h1>Goed gedaan!</h1>
        <h2>Jouw score:</h2>
        <div class="scoreContainer">
            <app-score :score="score"></app-score>
        </div>
        <!-- <div class="scoreTile" v-for="(point, index) in scoreArray" :key="index">
            <h1 :key="index">{{point}}</h1>
        </div>-->
        <button @click="restart" class="buttonAgain">
            <h3>Probeer opnieuw</h3>
        </button>
        <button v-if="nextLevelAvailable" @click="nextLevel" class="buttonAgain">
            <h3>Volgende level!</h3>
        </button>
    </div>
</template>

<script>
import Score from "./score.vue";

export default {
    name: "finalScore",
    components: {
        appScore: Score
    },
    props: {
        score: {
            type: Number,
            default: 0
        },
        currentLevel: {
            type:Number,
            required:true
        }
    },
    computed: {
        nextLevelAvailable() {
            if(this.currentLevel < 4) {
                return true
            } else {
                return false
            }
        },
        scoreArray() {
            var result = new Array();
            var scoreString = this.score.toString();
            if (scoreString.length == 1) {
                scoreString = "00" + scoreString;
            }
            if (scoreString.length == 2) {
                scoreString = "0" + scoreString;
            }
            result = Array.from(scoreString);
            return result;
        }
    },
    methods: {
        restart() {
            this.$emit("restart");
        },
        nextLevel() {
            this.$emit("nextLevel");
        }
    }
};
</script>
<style scoped>
.scoreContainer {
    margin: 0 auto;
    width: 75%;
    height: 20%;
}

.congrats {
    margin-top: 20%;
    padding: 5%;
    height: 20%;
}
h1 {
    font-size: 5vh;
    margin: 0;
    color: white;
    text-shadow: 0.8vh 0.8vh 0 #DB5900, -0.4vh -0.4vh 0 #DB5900, 0.4vh -0.4vh 0 #DB5900,-0.4vh 0.4vh 0 #DB5900, 0.4vh 0.4vh 0 #DB5900;
}
h2 {
    font-size: 4vh;
    margin: 5vh 0;
    color: white;
    text-shadow: 0.8vh 0.8vh 0 #DB5900, -0.4vh -0.4vh 0 #DB5900, 0.4vh -0.4vh 0 #DB5900,-0.4vh 0.4vh 0 #DB5900, 0.4vh 0.4vh 0 #DB5900;
}
h3 {
    font-size: 2.5vh;
    margin-top:-2vh;
    color: #fff;
}
.finalScore {
    position: absolute;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 15vh 0;
    background: rgba(22, 0, 0, 0.8);
}
.buttonAgain {
    display: inline-block;
    width: 40%;
    height: 30%;
    background:none;
    border:none;
    background-image: url(../assets/images/button-orange-up.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    margin:2vh;
}
.buttonAgain:hover {
    cursor: pointer;
    background-image: url(../assets/images/button-green-up.svg);
}
.buttonAgain:active {
    cursor: pointer;
    background-image: url(../assets/images/button-green-down.svg);
}
.buttonAgain:active h3 {
    margin-top:1vh;
}
</style>
